import xhr from '../utils/xhr';

let api = {
    get: (filters = { query: null }, sorting = { sortBy: "nameSort", direction: "asc" }, pagination = { pageSize: -1, pageNumber: -1 }) => {
        let searchFilter = filters.query !== null && filters.query.length ? `&nameFilter=${encodeURIComponent(filters.query)}` : ""
        return xhr.get({
            url: `/api/feeds/?pageNumber=${pagination.pageNumber}&pageSize=${pagination.pageSize}&sortBy=${sorting.sortBy}&direction=${sorting.direction}${searchFilter}`
        });
    },

    count: (filters = { query: null }) => {
        let searchFilter = filters.query !== null && filters.query.length ? `?nameFilter=${encodeURIComponent(filters.query)}` : ""
        return xhr.get({
            url: `/api/feeds/count/RMM${searchFilter}`
        });
    },
    deleteFeeds: (feedIds) => {
        return xhr.delete({
            url: "/api/feeds/",
            data: feedIds
        })
    }
};

export default api;


// WEBPACK FOOTER //
// ./src/scripts/api/Feeds.api.js